
import { useSnapshot } from "valtio";
import MessageModal from "../commons/CustomMsgModal";
import { colorWarningStore } from "../../stores/colorWarningStore";

const ColorWarningModal = () => {
  const snap = useSnapshot(colorWarningStore);

  const handleConfirm = () => {
    if (snap.onConfirmCallback) {
      snap.onConfirmCallback();
    }
    colorWarningStore.closeModal();
  };

  return (
    <MessageModal
      isOpen={snap.isOpen}
      title="WARNING"
      message="By removing or updating a color, 3D indications may reset to an unselected state."
      isWarning
      showCancel
      onConfirm={handleConfirm}
      onCancel={colorWarningStore.closeModal}
    />
  );
};

export default ColorWarningModal;